jQuery(($) => {

    function openInput($element) {
        $element.closest(".m-field").addClass("m-field--focused");
    }

    function maybeCloseInput($element) {
        if ($element.val() !== '') {
            $element.closest(".m-field").addClass("m-field--focused").removeAttr("style");
        } else {
            $element.closest(".m-field").removeClass("m-field--focused");
        }
    }

    if ($('.m-field input[type="text"]')[0]) {
        $(window).on('load', function () {
            var $inputs    = $(".m-field input[type='text'], .m-field input[type='email'], .m-field input[type='tel']"),
                $textareas = $(".m-field textarea");

            // If input or textarea has value, open it
            $inputs.each(function () {
                if ($(this).val() !== '') {
                    openInput($(this));
                }
            });

            $textareas.each(function () {
                if ($(this).val() !== '') {
                    openInput($(this));
                }
            });

            // If input or textarea focused, open it
            $inputs.focus(function () {
                openInput($(this));
            });

            $textareas.focus(function () {
                openInput($(this));
            });

            // If input or textarea blurred, close if has no value
            $inputs.blur(function () {
                maybeCloseInput($(this));
            });

            $textareas.blur(function () {
                maybeCloseInput($(this));
            });

        });
    }

    $(".m-field").mouseenter(function () {
        $(this).addClass('m-field--hovered');
    }).mouseout(function () {
        $(this).removeClass('m-field--hovered');
    }); 
});